export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9783.f28152ee.jpg";